export default __webpack_public_path__ + "static/media/OBResponseLogo.a4034c50.png";